module.exports = "/images/bg.svg?e2838f62238aaa156ebd6d8531743f2c";